import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/30">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          <div>
            <h4 className="font-heading text-lg font-bold text-foreground-900 mb-4">韩影深解</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              探索韩国电影的魅力世界——从经典佳作到最新力作，深度解析韩国电影的叙事风格、社会议题与文化内涵。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/crime-thriller" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">电影分类</Link>
              <Link to="/article/bong-joon-ho-narrative-evolution" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">深度解析</Link>
              <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/crime-thriller" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">犯罪悬疑</Link>
              <Link to="/category/romance-drama" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">爱情剧情</Link>
              <Link to="/category/horror-thriller" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">恐怖惊悚</Link>
              <Link to="/category/social-realism" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">社会现实</Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-800 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-500">邮箱：contact@hanyingshenjie.com</span>
              <span className="text-sm text-foreground-500">微信：韩影深解</span>
              <span className="text-sm text-foreground-500">微博：@韩影深解</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-10 pt-6 border-t border-background-300/30 max-w-7xl mx-auto">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 韩影深解 - 韩国电影推荐与深度解析。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}